import { useCallback, useRef } from "react";

import {
    DisclosureEventSender,
    recordDisclosurePlayFailed,
    recordDisclosurePlayed,
} from "JS/Helpers/DisclosureAnalytics";
import {
    DisclosurePlayEvent,
    DisclosurePlayReason,
} from "JS/Models/Disclosure";
import { useFirebaseLogger } from "JS/React/Hooks/Firebase";

export const useDisclosureAnalytics = () => {
    const { logFirebaseEvent } = useFirebaseLogger();

    const latest = useRef(logFirebaseEvent);
    latest.current = logFirebaseEvent;

    const send: DisclosureEventSender = useCallback((eventName, action) => {
        try {
            latest.current(eventName, action);
        } catch {
            // analytics must never reach playback
        }
    }, []);

    const recordPlayed = useCallback(
        (event: DisclosurePlayEvent) => {
            try {
                recordDisclosurePlayed(event, send);
            } catch {
                // analytics must never reach playback
            }
        },
        [send],
    );

    const recordPlayFailed = useCallback(
        (event: DisclosurePlayEvent & { reason: DisclosurePlayReason }) => {
            try {
                recordDisclosurePlayFailed(event, send);
            } catch {
                // analytics must never reach playback
            }
        },
        [send],
    );

    return { recordPlayed, recordPlayFailed };
};
